import axios from "axios";
const apiurl=process.env.REACT_APP_API_Base_Url;
export interface TableListItem {
  tableName: string;
  createdDate: string;
  createdBy: number;
  updatedDate: string;
  updatedBy: number;
  flgIsActive: boolean;
}

export const getTableList = async (): Promise<TableListItem[]> => {
  const response = await axios.get(
    `${apiurl}FileAction/getTableList`
  );
  return response.data?.data ?? [];
};


export interface TableColumnItem {
  label: string;
  value: string;
}

export const getTableColumns = async (tableName: string): Promise<TableColumnItem[]> => {
  const response = await axios.get(
    `${apiurl}FileAction/getTableColumn`,
    {
      params: { tableName }
    }
  );
  return response.data?.data ?? [];
};

export const getDynamicForecastResult = async (
  tableName: string,
  targetColumn: string,
  horizon: string,
  windowSize: string,
  dateColumn: string,
  requiredDetails: string
) => {
  const response = await axios.get(
    `${apiurl}DynamicForeCast/GetDynamicResult`,
    {
      params: {
        TableName: tableName,
        targetColumn,
        horizon,
        windowSize,
        DateColumn: dateColumn,
        RequiredDetails: requiredDetails
      }
    }
  );
  return response.data;
};